import React from 'react'

const FlexContainer = ({ flexClassName, children }) => {
  return <div className={`display-flex ${flexClassName}`}>{children}</div>
}

export default FlexContainer
